import styled from 'styled-components'

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
`

export const DialogContainer = styled.div`
  width: 500px;
  max-width: 90vw;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
  transform: translateY(0);
  animation: dialogFadeIn 0.3s ease;

  @keyframes dialogFadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const DialogForm = styled.form`
  display: flex;
  flex-direction: column;
  background: white;
`

export const DialogHeader = styled.div`
  background: linear-gradient(135deg, #3a8ffe, #486cdf);
  padding: 24px;

  h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    color: white;
    text-align: center;
  }
`

export const DialogContent = styled.div`
  padding: 24px;
  background-color: white;
`

export const InfoContainer = styled.div`
  background-color: #f8f9fa;
  border-left: 4px solid #3a8ffe;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 8px;

  h4 {
    color: #333;
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: 600;
  }

  p {
    color: #555;
    margin: 0;
    font-size: 15px;
    line-height: 1.5;
    word-wrap: break-word;
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px 24px;
  gap: 12px;
  background-color: white;
`

export const Button = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const AcceptButton = styled(Button)`
  background-color: #34c759;
  color: white;

  &:hover:not(:disabled) {
    background-color: #28a745;
    box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
  }
`

export const CancelButton = styled(Button)`
  background-color: #f1f3f5;
  color: #495057;

  &:hover:not(:disabled) {
    background-color: #e9ecef;
  }
`
